import { forwardRef } from 'react'
import ArrowRight from '~/components/UI/Buttons/icon/arrow-right'
import { NavigationMenuLink } from '~/components/UI/shadcn/navigation-menu'
import { cn } from '~/lib/utils'

export const MenuItem = forwardRef<
  React.ElementRef<'a'>,
  React.ComponentPropsWithoutRef<'a'>
>(({ className, title, children, ...props }, ref) => {
  return (
    <div role='listitem'>
      <NavigationMenuLink asChild>
        <a
          ref={ref}
          className={cn(
            'unstyled-link hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground group space-y-2xs-plus p-xs text-blue-d hover:bg-grey-l dark:hover:bg-grey-d block rounded-none leading-none no-underline outline-hidden transition-colors select-none',
            className
          )}
          {...props}
        >
          <div className='gap-2xs border-blue-d-40 stroke-blue-d pb-3xs text-blue-d group-hover:gap-xs group-focus:gap-xs relative z-0 flex w-fit items-center border-b-[1px] leading-none font-bold text-balance transition-all duration-200 group-hover:mr-0 group-focus:mr-0 dark:border-white/60 dark:stroke-white'>
            {title}

            <ArrowRight
              fill={''}
              width={'1.437rem'}
              height={'1.437rem'}
              title={''}
            />

            <svg
              height='2'
              width='100%'
              className='absolute -bottom-[1px] left-0 z-10 origin-left scale-x-0 transition-transform duration-200 group-hover:scale-x-100 group-focus:scale-x-100'
            >
              <rect
                x='0'
                y={2}
                width='100%'
                height='1'
                className='fill-blue-d dark:fill-white'
                strokeWidth='2'
                strokeLinecap='square'
              />
            </svg>
          </div>
          {children && (
            <span className='text-muted-foreground text-blue-d/80 dark:text-blue-d/80 line-clamp-2 text-base leading-snug'>
              {children}
            </span>
          )}
        </a>
      </NavigationMenuLink>
    </div>
  )
})
MenuItem.displayName = 'MenuItem'
